<template>
  <div class="content">
    <el-form :model="formData" ref="formData" label-width="180px">
      <el-form-item label="手机入驻开关">
        <el-radio-group v-model="formData.is_mobile">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
        <div class="state_text">是否允许商户从手机端申请入驻</div>
      </el-form-item>
      <el-form-item label="显示入驻申请协议">
        <el-radio-group v-model="formData.is_show">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="入驻协议名称" v-if="formData.is_show == '1'">
        <el-input v-model="formData.agree_title" class="input_box"></el-input>
      </el-form-item>
      <el-form-item label="协议内容" v-if="formData.is_show == '1'">
        <el-input
          v-model="formData.agree_content"
          class="input_box"
          type="textarea"
          rows="4"
        ></el-input>
      </el-form-item>
      <el-form-item label="入驻宣传头部图片">
        <el-upload
          ref="upload"
          class="avatar-uploader"
          action="https://www.58zltc.com/api/Upload/uploads/"
          :show-file-list="false"
          accept="image/*"
          :on-success="handleAvatarSuccess"
          :data="imgdata"
          :on-change="changefile"
          :auto-upload="false"
        >
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
    </el-form>
    <div class="bottom_btn">
      <el-button type="primary" @click="submit">提交</el-button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { MerchSet, EditSet } from "@/api/merchant";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  mounted() {
    this.$store.commit("SET_STATE", "2");
    this.init();
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("SET_STATE", "1");
    next();
  },
  data() {
    return {
      formData: {},
      imageUrl: "", //上传的图片地址
      imgdata: {}, //上传图片附加信息
      image_id: "", //上传后服务器路径
      if_add: true
    };
  },
  methods: {
    init() {
      console.log(this.$route.query);
      MerchSet({ token: this.token, app_id: this.app_id }).then(res => {
        this.formData = Object.assign({}, res.data);
        this.imageUrl = res.data.image;
      });
    },
    submit() {
      if (this.imageUrl != "") {
        this.$refs.upload.submit();
      }
    },
    // 图片上传
    // 文件选取的时候调用
    changefile(file, fileList) {
      this.imageUrl = URL.createObjectURL(file.raw);
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      console.log(file, fileList);
      this.imgdata = {
        token: this.token,
        image: file.raw,
        type: "1",
        file_group: "1"
      };
    },
    //上传成功
    handleAvatarSuccess(res, file) {
      console.log(res);
      this.imageUrl = URL.createObjectURL(file.raw);
      this.image_id = res.data.id;
      this.save();
    },
    //保存表单
    save() {
      var data = Object.assign({}, this.formData);
      data.image_id = this.image_id;
      data.token = this.token;
      data.app_id = this.app_id;
      console.log(data);
      EditSet(data).then(res => {
        if (res.code == "1") {
          this.$message({
            type: "success",
            message: res.msg
          });
        }
      });
    }
  }
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-top: 10px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
</style>
<style lang="scss" scoped>
.content {
  font-size: 14px;
  .input_box {
    width: 400px;
  }
  .state_text {
    color: #999;
    font-size: 12px;
    height: 20px;
    line-height: 30px;
  }
  .bottom_btn {
    margin-left: 180px;
    margin-top: 30px;
    .ml30 {
      margin-left: 30px;
    }
  }
  // 图片上传
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 320px;
    height: 160px;
    line-height: 160px;
    text-align: center;
  }
  .avatar {
    width: 320px;
    height: 160px;
    display: block;
  }
}
</style>
